var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found-wrapper"},[_c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Page Not Found.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Login")])],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }